import styled from "styled-components";

export const StyledLayout = styled.div`
    .outlet{
        position: relative;

        .navbar-main{
            position: absolute;
            top:40px;
            width: 100%;
            z-index: 10;
        }
    }
`